import * as React from "react";
import { createPortal } from "react-dom";
import http from "shared/http";

const BUILD_VERSION_KEY = "app_build_version";
const POLL_INTERVAL_MS = 2 * 60 * 1000;

const BuildUpdateBanner: React.FC = () => {
  const [showBanner, setShowBanner] = React.useState(false);
  const pendingVersionRef = React.useRef<string>("");

  React.useEffect(() => {
    let cancelled = false;

    const checkVersion = async () => {
      try {
        const version = (await http.fetchAsync("app/Version")) as string;
        if (cancelled || !version) return;
        const stored = localStorage.getItem(BUILD_VERSION_KEY);
        if (!stored) {
          localStorage.setItem(BUILD_VERSION_KEY, version);
          return;
        }
        if (stored !== version) {
          pendingVersionRef.current = version;
          setShowBanner(true);
        }
      } catch {
        // ignore — don't show the banner on fetch failure
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (!showBanner) return null;

  return createPortal(
    <div className="cp-update-banner">
      <i className="fa-solid fa-rotate cp-update-banner-icon" />
      <span>A new version is available.</span>
      <button
        className="cp-update-banner-btn"
        onClick={() => {
          localStorage.setItem(BUILD_VERSION_KEY, pendingVersionRef.current);
          window.location.reload();
        }}
      >
        Update now
      </button>
      <button
        className="cp-update-banner-dismiss"
        title="Dismiss"
        onClick={() => setShowBanner(false)}
      >
        <i className="fa-solid fa-xmark" />
      </button>
    </div>,
    document.body,
  );
};

export default BuildUpdateBanner;
